import { Component, Input } from '@angular/core';
import { DisplayOptions, Filter, PreviewCustomRule } from '../../models/filter-models';
import { DisplayType, EquipmentTierType } from "../../models/enums";
import { Rarity } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { FilterService } from '../../services/filter.service';
import { CustomRuleStylePickerComponent } from '../../common/style-picker/custom-rule-style-picker/custom-rule-style-picker.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { Tier } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { heistLocations, heistRewards } from '../../data/poe1/heist-data';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules, ActiveSpecialRules } from '../../services/filter-generator.service';
import { EquipmentType } from '../../models/equipment-type.enum';
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';

@Component({
  selector: 'app-other-item-filters',
  imports: [FormsModule, AutocompleteComponent, FilterTitleComponent, CustomRuleStylePickerComponent,
    EquipmentTierPickerComponent, FilterCheckboxGroupComponent],
  templateUrl: './other-item-filters.component.html',
  styleUrl: './other-item-filters.component.scss'
})
export class OtherItemFiltersComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  goldKeyStyle = new PreviewCustomRule({ displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Item }) });
  silverKeyStyle = new PreviewCustomRule({ displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Item }) });
  bronzeKeyStyle = new PreviewCustomRule({ displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.DWhite, displayTypeTierHighlightType: EquipmentTierType.Item }) });

  heistLocations: { name: string, image?: string }[] = [
    { name: 'Bunker' },
    { name: 'Records Office' },
    { name: 'Mansion' },
    { name: 'Smuggler\'s Den' },
    { name: 'Underbelly' },
    { name: 'Laboratory' },
    { name: 'Prohibited Library' },
    { name: 'Repository' },
    { name: 'Tunnels' },
  ];

  heistSkillsData: { name: string, image: string }[] = [];
  heistRewardsData: { name: string, image: string }[] = [];

  relicBaseTypeAutocompleteOptions: { name: string, image: string }[] = [];

  Rarity = Rarity;
  DisplayType = DisplayType;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();
    this.relicBaseTypeAutocompleteOptions = this.itemDataService.getItemData().find(i => i.itemType === 'Relics')!.baseTypes.map(b => ({ name: b.name, image: b.image! }));
    this.heistSkillsData = Array.from(new Set(heistLocations.flatMap(location => location.skills))).map(skill => ({ name: skill.replace('-', ' '), image: `/img/heist/skills/${skill}.png` }));
    this.heistRewardsData = Array.from(new Set(heistRewards.flatMap(reward => reward.rewards))).map(reward => ({ name: reward.replace('-', ' '), image: `/img/heist/rewards/${reward}.png` }));
  }

  toggleHighlight(displayOptions: DisplayOptions) {
    displayOptions.active = !displayOptions.active;
  }

  EquipmentType = EquipmentType;

  toggleHighlightRareWaystones = () => {
    this.filter.showRareWaystones = !this.filter.showRareWaystones;
    this.updateFilter();
  }

  toggleHighlightQuestItems = () => { this.filter.showQuestItems = !this.filter.showQuestItems; this.updateFilter(); }
  toggleHighlightTrialItems = () => {
    this.filter.showTrialItems = !this.filter.showTrialItems;
    if (!this.filter.showTrialItems) {
      this.filter.hideOtherTrialItems = false;
    }
    this.updateFilter();
  }
  toggleHideOtherTrialItems = () => {
    if (this.trialHideOtherRelicsDisabled) return;
    this.filter.hideOtherTrialItems = !this.filter.hideOtherTrialItems;
    this.updateFilter();
  }

  onTrialRelicTypesChange(values: string[]) {
    this.filter.showTrialItemTypes = values;
    if (values.includes('All')) {
      this.filter.hideOtherTrialItems = false;
    }
    this.updateFilter();
  }

  trialRelicExampleName(): string {
    const picked = this.filter.showTrialItemTypes.find(t => t !== 'All');
    return picked ?? this.relicBaseTypeAutocompleteOptions[0]?.name ?? 'Tapestry Relic';
  }

  get trialHideOtherRelicsDisabled(): boolean {
    return !this.filter.showTrialItems || this.filter.showTrialItemTypes.includes('All');
  }

  toggleHighlightTrialKeys = () => { this.filter.showTrialKeys = !this.filter.showTrialKeys; this.updateFilter(); }

  toggleHighlight6LinkedItems = () => { this.filter.show6LinkedGear = !this.filter.show6LinkedGear; this.updateFilter(); }
  toggleHighlightHeistBlueprints = () => {
    this.filter.showHeistBlueprints = !this.filter.showHeistBlueprints;
    if (!this.filter.showHeistBlueprints) {
      this.filter.showHeistContracts = false;
    }
    this.updateFilter();
  }
  toggleHighlightHeistContracts = () => { this.filter.showHeistContracts = !this.filter.showHeistContracts; this.updateFilter(); }
  toggleHighlightHeistEnchantedBlueprints = () => {
    this.filter.showHeistEnchantedBlueprints = !this.filter.showHeistEnchantedBlueprints;
    if (!this.filter.showHeistEnchantedBlueprints) {
      this.filter.showHeistEnchantedContracts = false;
    }
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
